import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Data } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PatrolGroupService } from '../../../service/patrol-group.service';
import { FacilityGroupEquipmentComponent } from '../facility-group-equipment/facility-group-equipment.component';
import { FacilityGroupInfoComponent } from '../facility-group-info/facility-group-info.component';

@Component({
  selector: 'app-facility-group',
  templateUrl: './facility-group.component.html',
  styleUrls: ['./facility-group.component.less']
})
export class FacilityGroupComponent implements OnInit {

  validateForm: FormGroup;
  groupType = [{ value : 0, label : '固定资产组'}, { value : 1, label : '巡检区域组'}];
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  listOfData = [];
  listOfCurrentPageData: Data[] = [];
  startRow: number;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  setOfCheckedItem = new Set<Data>();

  constructor(
    private fb: FormBuilder,
    private groupService: PatrolGroupService,
    public message: NzMessageService,
    private modal: NzModalService,
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }

  ngOnInit(): void {
    this.validateForm = this.fb.group({ groupName: null });
    this.queryGroupListData(1);
  }

  /**
   *   @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryGroupListData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.groupService.queryGroupDataByCondition(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '巡检组数据查询失败!');
      return;
    } else {
      this.listOfData = result.data.list;
      this.total = result.data.total;
      this.startRow = result.data.startRow;
    }
  }

  addGroup(){
    const modal = this.modal.create({
      nzTitle: '新增巡检组',
      nzContent: FacilityGroupInfoComponent,
      nzStyle: { top: '40px' },
      nzWidth: 360,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        data: null,
      }
    });
    modal.afterClose.subscribe(() => { this.queryGroupListData(1); });
  }
  // 发消息显示BIM
  groupBIMData(value: any){
    // const modal = this.modal.create({
    //   nzTitle: '资产组BIM展示',
    //   nzContent: MultipleDeviceComponent,
    //   nzOkText: null,
    //   nzFooter: null,
    //   nzCancelText: null,
    //   nzMaskClosable: false,
    //   // nzCentered: true,
    //   nzBodyStyle: { padding: '10px', height: '840px'},
    //   nzWidth: 1600,
    //   nzComponentParams: {
    //     epData: value,
    //   }
    // });
  }

  groupData(value: any){
    const modal = this.modal.create({
      nzTitle: value.groupType === '0' ? '资产列表' : '区域列表',
      nzContent: FacilityGroupEquipmentComponent,
      nzStyle: { top: '40px' },
      nzWidth: 1000,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        data: value,
      }
    });
  }

  editData(value: any){
    const modal = this.modal.create({
      nzTitle: '修改巡检组',
      nzContent: FacilityGroupInfoComponent,
      nzStyle: { top: '40px' },
      nzWidth: 500,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        data: value,
      }
    });
    modal.afterClose.subscribe(() => { this.queryGroupListData(1); });
  }

  async deleteData(data: any){
    this.modal.confirm({
      nzTitle: '您确定要删除该条记录吗？',
      nzContent: '当点击确定时，该条记录将会从列表中被删除！',
      nzOkDanger: true,
      nzOnOk: async () => {
        const result: any = await this.groupService.deleteGroup(data);
        if (result.code === 200) {
          this.message.create('success', '删除巡检组成功!');
          this.queryGroupListData(1);
        } else {
          this.message.create('error', '删除巡检组失败!');
        }
      }
    });
  }

  submitForm() {
    this.queryGroupListData(1);
  }

  resetForm() {
    this.validateForm.setValue({ groupName: null });
    this.queryGroupListData(1);
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryGroupListData(2);
  }

  onAllChecked(checked: boolean): void {
    this.listOfCurrentPageData.forEach(data => this.updateCheckedSet(data, checked));
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    const listOfEnabledData = this.listOfCurrentPageData;
    this.checked = listOfEnabledData.every(data => this.setOfCheckedId.has(data.spNo));
    this.indeterminate = listOfEnabledData.some(data => this.setOfCheckedId.has(data.spNo)) && !this.checked;
  }

  updateCheckedSet(data: Data, checked: boolean): void {
    if (checked) {
      this.setOfCheckedItem.add(data);
      this.setOfCheckedId.add(data.spNo);
    } else {
      this.setOfCheckedItem.delete(data);
      this.setOfCheckedId.delete(data.spNo);
    }
  }

  onItemChecked(data: Data, checked: boolean): void {
    this.updateCheckedSet(data, checked);
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange(listOfCurrentPageData: Data[]): void {
    this.listOfCurrentPageData = listOfCurrentPageData;
    this.refreshCheckedStatus();
  }

}
